export default function FourOFour() {
    return (
        <h1>404</h1>
    );
}